export default __webpack_public_path__ + "static/media/cu_medi_logo_landscape.301c2c5a.jpg";